import { Controller } from "@hotwired/stimulus";
import { pronounce } from "../components/lib/pronunciation";

export default class extends Controller {
  static values = { text: String, lang: String };

  async play(event) {
    const button = event.currentTarget;
    button.disabled = true;
    try {
      await pronounce({ text: this.textValue, lang: this.langValue });
    } finally {
      button.disabled = false;
    }
  }
}
